import { Icon } from './icons'

const STAGES: [string, string, string, string, string][] = [
  ['1', 'Aprendizado', 'A IA observa mensagens, respostas, pedidos e notas internas. Nada é enviado automaticamente.', 'done', 'Concluído'],
  ['2', 'Respostas sugeridas', 'A IA propõe respostas prontas acima do campo de digitação. O agente decide o que enviar.', '', 'Próximo'],
  ['3', 'Atendimento autônomo', 'A IA responde diretamente ao cliente. O agente pode assumir a conversa a qualquer momento.', '', 'Futuro'],
]

/**
 * Static placeholder per Phase 2 scope — no LLM call, no suggestion generation. Kept because
 * the approved UI includes it, and because the messaging engine underneath (visibility, audit
 * log, sender_type='ai') is already shaped for the moment this becomes real.
 */
export function IaSection() {
  return (
    <div className="ph">
      <div className="ph-in">
        <div className="ph-ic">
          <Icon name="spark" />
        </div>
        <h2>IA</h2>
        <p>
          A IA acompanha o atendimento da equipe e evolui em três estágios. Nesta fase, o motor de mensagens já
          registra tudo o que uma IA futura vai precisar — mas nenhuma sugestão é gerada ainda.
        </p>
        <div className="ph-card">
          <h3>Estágios</h3>
          <div className="d">Estágio atual: aprendizado</div>
          {STAGES.map(([n, t, s, cls, badge]) => (
            <div className={`stage-row ${cls}`} key={n}>
              <span className="stage-n">{n}</span>
              <div>
                <div className="t">{t}</div>
                <div className="s">{s}</div>
              </div>
              <span className="stage-badge">{badge}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
